import React, { Fragment } from 'react'
import { Route } from 'react-router-dom';
import { WorkerCapturedAuditReportSundryListing } from './Pages'

export const WorkerCapturedAuditReportSundryRoutes = ({ match }) => (
    <Fragment>
        <Route exact path={`${match.path}`} component={WorkerCapturedAuditReportSundryListing} />
    </Fragment>
)